<template>
  <div class="hosts-dashboard-content">
    <slot v-if="agent">
      <div id="host-details" class="host-data-wrapper">
        <div class="title">Host</div>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Criticality</el-col>
          <el-col :span="18" class="content">
            <div class="icon-criticality" @click.stop.prevent="toggleCriticalityDialog">
              <i
                  class="display-block icon"
                  :class="`icon-criticality-${agent.criticality ? agent.criticality.toLowerCase() : ''}`"
              ></i>
              <div class="criticality-name capitalize-first-letter">{{ agent.criticality }}</div>
            </div>
          </el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> OS</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.os }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Kernel</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.kernel }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Release</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.release }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Version</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.version }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Platform</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.platform }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> CPUs</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.cpus }}</el-col>
        </el-row>
      </div>
      <div id="host-agent" title="Agent" class="host-data-wrapper">
        <div class="title">Agent</div>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Status</el-col>
          <el-col :span="18" class="content">
            <el-tag v-if="agent.agentDetails.agentStatus === 'ONLINE'" size="mini" type="success">ONLINE</el-tag>
            <el-tag v-if="agent.agentDetails.agentStatus !== 'ONLINE'" size="mini" type="danger">OFFLINE</el-tag>
          </el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Name</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.agentId }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Created</el-col>
          <el-col :span="18" class="content"> {{ formattedCreateTime }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Last Status Change</el-col>
          <el-col :span="18" class="content">
            {{ formattedLastStatusTime }}
          </el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Events Consumed</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.eventsConsumed }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Aggregated Risk Score</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.aggregatedRiskScore }}</el-col>
        </el-row>
      </div>
      <div id="host-network" title="Network" class="host-data-wrapper">
        <div class="title">Network</div>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Hostname</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.customHostname }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Private IPs</el-col>
          <el-col :span="18" class="content">
            <div v-for="ip in agent.agentDetails.privateIPs" :key="ip">{{ ip }}</div>
          </el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Public IPs</el-col>
          <el-col :span="18" class="content">
            <div v-for="ip in agent.agentDetails.publicIPs" :key="ip">{{ ip }}</div>
          </el-col>
        </el-row>
      </div>
      <div
          v-if="agent.agentDetails.system.ec2Instance"
          id="host-configuration"
          class="host-data-wrapper"
      >
        <div class="title">Cloud Configuration</div>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> AMI ID</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.ec2Instance.amiId }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Availability Zone</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.ec2Instance.availabilityZone }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Instance ID</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.ec2Instance.instanceId }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Instance Type</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.ec2Instance.instanceType }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Local Hostname</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.ec2Instance.localHostname }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Local IPv4</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.ec2Instance.localIpv4 }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Public Hostname</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.ec2Instance.publicHostname }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Public IPv4</el-col>
          <el-col :span="18" class="content"> {{ agent.agentDetails.system.ec2Instance.publicIpv4 }}</el-col>
        </el-row>
        <el-row class="host-data-row" :gutter="20">
          <el-col :span="6" class="name"> Security Groups</el-col>
          <el-col :span="18" class="content">
            {{ joinedSecurityGroups }}
          </el-col>
        </el-row>
      </div>
    </slot>
  </div>
</template>
<script>
import moment from "moment-timezone";
import {DATETIME_FORMAT_LONG, NANOSECONDS_TO_MILLISECONDS} from "../../constants/datetime.constants";
import EditCriticalityDialog from "./EditCriticalityDialog.vue";

export default {
  name: 'HostDetailsCard',
  components: {EditCriticalityDialog},
  props: {
    agent: {
      default() {
        return {}
      },
      type: [Array, Object]
    },
    onEditCriticalityClick: {
      type: [Function],
      default() {
        return undefined;
      }
    }
  },
  data() {
    return {
      activeDetailsCollapse: ['host-details', 'host-agent', 'host-network', 'host-configuration'],
      agentEmpty: null,
      formattedCreateTime: null,
      formattedLastStatusTime: null,
      joinedSecurityGroups: null
    }
  },
  created() {
    this.agentEmpty = _.isEmpty(this.agent.agentDetails)
    if (!this.agentEmpty) {
      // Format dates
      this.formattedCreateTime = this.formatDateTime(this.agent.agentDetails.createTime)
      this.formattedLastStatusTime = this.formatDateTimeNS(this.agent.agentDetails.lastStatusChangeTime)

      // Split strings
      this.joinedSecurityGroups = this.agent.agentDetails.system.ec2Instance.securityGroups.split(/\n/).join(', ')
    }
  },
  methods: {
    formatDateTime(datetime) {
      return moment(datetime).format(DATETIME_FORMAT_LONG)
    },
    formatDateTimeNS(datetime) {
      return this.formatDateTime(datetime * NANOSECONDS_TO_MILLISECONDS)
    },
    toggleCriticalityDialog() {
      this.onEditCriticalityClick()
    }
  },
  computed: {
    getLastSeen() {
      if (_.isEmpty(this.agent.agentDetails)) {
        return ''
      }
      const timeStamp = new Date(this.agent.agentDetails.createTime)
      const timeStampArr = timeStamp.toString('MMM dd').split(' ')
      const date = `${timeStampArr[1]} ${timeStampArr[2]}, ${timeStampArr[3]}  ${timeStamp.toLocaleTimeString('en-US')}`
      return date
    },
    getStatusInfo() {
      if (_.isEmpty(this.agent.agentDetails)) {
        return {
          text: '',
          color: '',
          size: ''
        }
      }
      let statusText, statusColor
      let statusSize = 'medium'
      if (
          this.agent.agentDetails.agentStatus === 'ONLINE' &&
          this.agent.agentDetails.aggregatedRiskScore === 0
      ) {
        statusText = 'SAFE'
        statusColor = '#e1f2ff'
      } else if (
          this.agent.agentDetails.agentStatus === 'ONLINE' &&
          this.agent.agentDetails.aggregatedRiskScore > 0
      ) {
        statusText = 'At Risk'
        statusColor = '#feebee'
      } else {
        statusText = 'OFFLINE'
        statusColor = '#f8f8f8'
      }

      return {
        text: statusText,
        color: statusColor,
        size: statusSize
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/icon.css';

.host-data-wrapper {
  .host-data-row {
    padding: 10px 8px 5px 15px;
    font-size: 13px;
    display: flex;

    .name {
      width: 50%;
    }

    .content {
      width: 50%;
    }
  }

  .title {
    border-bottom: 1px solid #C6CBD2;
    background: #F3F4F4;
    display: flex;
    align-items: center;
    color: #404C5A;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px; /* 320% */
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 3px 8px 5px 15px;
  }
}

.hosts-dashboard-content {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
}

.scroll-menu {
  position: fixed;
}

.scroll-menu h5 {
  margin-top: 0.5em;
  margin-bottom: 1.5em;
}

.scroll-menu a {
  display: block;
  margin: 0.5em 0;
}

.name {
  color: #303133;
  font-size: 12px;
  font-weight: bold;
}

.el-row {
  margin-bottom: 5px;
}

.icon {
  background: none;
  margin: 0px 5px 0px 0px;
  font-size: 16px;
  color: var(--aluminum-600);
}

.icon-criticality {
  display: flex;
  cursor: pointer;
  align-items: center;

  .icon {
    background: #0066E3;
    line-height: 24px;
  }

  .criticality-name {
    color: #0066E3;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/hosts/HostDetailsCard.vue